import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import GeoAutoCompletion from "components/GeoAutoCompletion";
import useText from "constants/text";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useRegistrationContext } from "../../../contexts/Registration";
import { Address } from "../../../generated/graphql";
import { activities } from "../Interface";
import { useStyles } from "./styles";
import { StepOneValidation } from "./validators";

export interface IProps {
  onNext?: React.Dispatch<React.SetStateAction<number>>;
}

interface IStepOneValues {
  client_address: unknown;
  client_company_name: string;
  client_activity: string;
}

const defaultValues: IStepOneValues = {
  client_address: "",
  client_company_name: "",
  client_activity: null,
};

export default function StepOneOfRegister({ onNext }: IProps) {
  const styles = useStyles();
  const { text } = useText();
  const { client, setClient } = useRegistrationContext();
  const [isFormSubmited, setFormSubmited] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);

  useEffect(() => {
    setFormValues({
      client_activity: client?.client_activity,
      client_company_name: client?.client_company_name,
      client_address: client?.client_address,
    });
  }, []);

  const handleChange = (value: Address) => {
    setFormValues({ ...formValues, client_address: value });
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFormValues({ ...formValues, client_company_name: e.target.value });
  };

  const handleNext = () => {
    setFormSubmited(true);
    if (!StepOneValidation.isValidSync(formValues)) return;
    setClient({ ...client, ...formValues });
    onNext(1);
  };
  const handleSelect = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setFormValues({ ...formValues, client_activity: event.target.value as string });
  };

  const fieldsErrors = React.useMemo<Partial<Record<keyof IStepOneValues, boolean>>>(() => {
    const errors: Partial<Record<keyof IStepOneValues, boolean>> = {};
    if (isFormSubmited) {
      Object.keys(formValues).forEach((key) => {
        try {
          StepOneValidation.validateSyncAt(key, formValues);
        } catch (error) {
          errors[key] = true;
        }
      });
      return errors;
    }
    return {};
  }, [isFormSubmited, formValues]);

  const backToWebsite = () => {
    window.location.replace("https://papslogistics.com/");
  };

  return (
    <Grid container  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center"}}>
      <Grid item xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          label={text.all.entreprise}
          name="client_company_name"
          value={formValues?.client_company_name}
          error={fieldsErrors.client_company_name}
          placeholder={text.all.entreprise}
          onChange={onChange}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl variant="outlined" fullWidth required>
          <InputLabel id="client_activity">{text.all.activity}</InputLabel>
          <Select
            id="client_activity"
            value={formValues?.client_activity}
            onChange={handleSelect}
            label="Activité"
            name="client_activity"
            error={fieldsErrors.client_activity}
          >
            {activities.map((index) => (
              <MenuItem key={index} value={index}>
                {index}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <GeoAutoCompletion
          address={formValues?.client_address}
          onChange={handleChange}
          placeholder={text.all.address}
          required
          error={fieldsErrors.client_address}
        />
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <div className={styles.buttons}>
          <Button className={styles.back} onClick={backToWebsite}>
            {text.all.return_to_the_website}
          </Button>
          <Button variant="contained" color="primary" onClick={handleNext} className={styles.log}>
            {text.all.next}
          </Button>
        </div>
      </Box>
    </Grid>
  );
}
